import { createSelectorsFromModel } from '@/helpers/redux';

const model = {
    agencyDetails: null,
    loading: false,
    error: null,

    agencyServices: [],
    fetchingLoading: true,
    fetchingError: null,
    isLoadingMore: false,
    isLoadingMoreError: null,
    hasMore: false,
};

export const selectors = createSelectorsFromModel(
    (state) => state.b2b.agencyprofile,
    model,
);

export default model;
